import { registerPlugin } from '@capacitor/core';

import { IAppRate } from './types';

export const AppRate = registerPlugin<IAppRate>('AppRate', {
  web: () => import('./web').then((m) => new m.AppRateWebPlugin()),
});
